import virtualOutputComponentProvider from "../../../../../../../utils/virtualOutputComponentProvider";
import formatTime from "mn-utils/formatTime";
import InfoIcon from "../../../../../../icons/Info";
import Ripple from "../../../../../../dumb/Ripple";
import {Link} from "../../../../../../../router";
import * as links from "../../../../../../../constants/links";
import RowA from "../../../../../../dumb/Row/A";
import ColA from "../../../../../../dumb/Col/A";
import {
  DisplayAmountAdmin,
  DisplayDataAdmin,
  DisplayDateTimeAdmin,
  DisplayIdAdmin
} from "../../../../../../dumb/DisplayData";
import Tooltip from "../../../../../../dumb/Tooltip/A";
import upperFirst from "mn-utils/upperFirst";
import WrapperWithLoading from "../../../../../../dumb/WrapperWithLoading";
import ButtonD from "../../../../../../dumb/Button/D";
import RefreshIcon from "@material-ui/icons/Refresh";
import RowB from "../../../../../../dumb/Row/B";
import ColB from "../../../../../../dumb/Col/B";
import ButtonUp from "../../../../../../dumb/Button/Up";
import React from "react";
import {
  apiAdminBankingAccount,
  apiAdminPayoutVertoCompletedList, apiAdminPayoutVertoUpdate,
} from "../../../../../../../api/admin/payout/verto";
import {openPopupWindow, openV1PopupInfo} from "../../../../../../../emitters/popup";
import {CURRENCY_ITEMS} from "../../../../../../../constants";
import Select from "../../../../../../dumb/Select/B";
import Popup from "../../../../../../dumb/Popup/C";
import Switch from "../../../../../../dumb/Switch/D";
import TextField from "../../../../../../dumb/TextField/H";
import ColB2 from "../../../../../../dumb/Col/B2";
import ColA2 from "../../../../../../dumb/Col/A2";
import FieldC from '../../../../../../dumb/Field/A';
import ButtonCancel from "../../../../../../dumb/Button/I";
import {openPopupSend} from "../../utils/openPopupSend";
import ResendMoneyIcon from "../../../../../../icons/ResendMoney";
import PencilIcon from "../../../../../../icons/Pencil";

const STATUS_CLASS_MAP = {
  initiated: 'i',
  pending: 'p',
  completed: 'c',
  failed: 'f',
};


const openBankingInfo = (data, update) => openPopupWindow((setPopupState, popup, onPopupMount) => {
  popup.state = {
    ...popup.state,
    bankInfo: {},
    loading: true
  }

  onPopupMount(() => {
    apiAdminBankingAccount({account_id: data.account_id, bank_id: data.bank_id})
        .then((res = {}) => {
          if (!res.item) return;
          setPopupState({bankInfo: res.item});
        })
        .catch(popup.close)
        .finally(() => setPopupState({loading: false}));
  })

  return (state) => {

    const {name, iban, code, fiat_code: fiatCode} = state.bankInfo;
    const fieldsList = [
      {
        name: 'Bank name',
        value: name
      },
      {
        name: 'IBAN',
        value: iban
      },
      {
        name: 'Bank code',
        value: code
      },
      {
        name: 'Fiat Code',
        value: fiatCode
      },
    ]

    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Bank Data</div>
            <div className="mh30 fw3 rlv st-2">|</div>
            <div className="f12 fx1 wmin0 tov ov wsNW">{data.bank_id}</div>
          </div>
        )}
        beforeButtons={(
          <div className="pr40 mv-10 mr-15">
            <ButtonCancel
              onClick={popup.close}
            >
              <div className="layoutRow fhaC fvaC rlv st1 w170">
                <div>Close</div>
              </div>
            </ButtonCancel>
          </div>
        )}
      >
        <WrapperWithLoading
          loading={state.loading}
        >
          {fieldsList.map(({name, value}) => (
            <div key={name} className="mt15">
              <FieldC
                label={name}
                value={value || '-'}
              />
            </div>
          ))}
        </WrapperWithLoading>
      </Popup>
    )
  }
})



const vertoTableCtor = (api) => virtualOutputComponentProvider({
  rowHeight: 70,
  request: api,
  wrapper(render, setState, self) {
    function Item({data}) {
      const id = data.id || '';
      const shortID = data.short_id || '';
      const withdrawalDate = data.created_at || null;
      const tx = data.tx || {};

      const merchantName = data.merchant_name || '';
      const merchantEmail = data.merchant_email || '';
      const currency = data.fiat_code || '';
      const amount = data.amount || '';
      const adminCurrency = tx.converted_asset_code || '';
      const adminAmount = tx.converted_amount || '';
      const adminComment = tx.admin_comment || '';
      const status = data.status;

      // const bankInfoDisabled = !adminAmount && !adminComment;
      const sendDisables = false;
      const bankInfoDisabled = false;

      return (
        <Ripple
          component={Link}
          href={`${links.LINK_ADMIN_PAYOUT_VERTO_GROUP_INFO}/${id}`}
          className="olN tdN dB w cF dn bgF.03:h"
        >
          <RowA className="f12">
            <ColA className="wmin155 fx1">
              {shortID ? (
                <>
                  <DisplayIdAdmin>{shortID}</DisplayIdAdmin>
                  <DisplayIdAdmin className="wsNW wmax fhaS c717275 mt3 f12 fw4">
                    {id}
                  </DisplayIdAdmin>
                </>
              ) : (
                <DisplayIdAdmin>{id}</DisplayIdAdmin>
              )}
            </ColA>
            <ColA className="wmin147">
              <DisplayDateTimeAdmin
                date={withdrawalDate}
              />
            </ColA>
            <ColA className="wmin130 fx1">
              <DisplayDataAdmin>{merchantName}</DisplayDataAdmin>
            </ColA>
            <ColA className="wmin130 fx1">
              <DisplayDataAdmin>{merchantEmail}</DisplayDataAdmin>
            </ColA>
            <ColA className="wmin150 fx1">
              <DisplayAmountAdmin
                amount={amount}
                symbol={currency}
                type="fiat"
              />
            </ColA>
            <ColA className="wmin180 fx1">
              <DisplayAmountAdmin
                amount={adminAmount}
                symbol={adminCurrency}
                type="fiat"
              />
            </ColA>
            <ColA className="wmin450 fx1">
              <DisplayDataAdmin>
                {adminComment}
              </DisplayDataAdmin>
            </ColA>
            <ColA className="wmin130 fx1">
              <Tooltip>
                <span className={'(cA294FF).i (cFFBF43).p (c2CE889).c (cEE4F4F).f) ' + STATUS_CLASS_MAP[status]}>
                  {upperFirst(status)}
                </span>
              </Tooltip>
            </ColA>
            <ColA2 className="w50">
              <Tooltip title="Edit" disabledCopy>
                <Ripple
                  className={
                    `w42 h42 p7 r7 (bgc0.25):h:not[.disabled] (o15).disabled`
                    + (sendDisables ? ' disabled' : '')
                  }
                  onClick={() => openPopupSend({...data, editMode: true}, self.update)}
                  disabled={sendDisables}
                >
                  <PencilIcon className="w25 h25"/>
                </Ripple>
              </Tooltip>
            </ColA2>
            <ColA2 className="w50">
              <Tooltip title="Bank Info" disabledCopy>
                <Ripple
                  className={
                    `w42 h42 p7 r7 (bgc0.25):h (bgc0.25):h:not[.disabled] (o15).disabled`
                    + (bankInfoDisabled ? ' disabled' : '')
                  }
                  disabled={bankInfoDisabled}
                  onClick={() => {
                    openBankingInfo(data);
                  }}
                >
                  <InfoIcon />
                </Ripple>
              </Tooltip>
            </ColA2>
          </RowA>
        </Ripple>);
    }

    return (state) => {
      return (
        <>
          <div className="h75 layoutRow jcFE aiC">
            <WrapperWithLoading
              loading={state.loading}
            >
              <ButtonD
                className="wmin100"
                onClick={self.update}
              >
                <RefreshIcon/>
                <div className="pl15">Refresh</div>
              </ButtonD>
            </WrapperWithLoading>
          </div>
          <div className="rlv h100vh-240 mh-45">
            <div className="ovxA abs s ph45">
              <div className="wmin1550 rlv h">
                <RowB className="f14">
                  <ColB className="wmin155 fx1">ID</ColB>
                  <ColB className="wmin147">Withdrawal Date</ColB>
                  <ColB className="wmin130 fx1">Name</ColB>
                  <ColB className="wmin130 fx1">Email</ColB>
                  <ColB className="wmin150 fx1">Original Amount</ColB>
                  <ColB className="wmin180 fx1">Settlement Amount</ColB>
                  <ColB className="wmin450 fx1">Payout Details</ColB>
                  <ColB className="wmin130 fx1">Status</ColB>
                  <ColB2 className="w50"/>
                  <ColB2 className="w50"/>
                </RowB>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </>
      );
    };
  },
}, {});

module.exports = {
  VertoTableCompleted: vertoTableCtor(apiAdminPayoutVertoCompletedList)
}
